import { CheckCircleOutline as CheckIcon, ErrorOutlineRounded } from '@mui/icons-material';
import { ItemButton } from './common/basic-step/ItemButton';
import { RenderComponent } from './common/ui/RenderComponent';
import { RenderMessageWithIcon } from './common/ui/RenderMessageWithIcon';
import { getStep } from '../registry/workflowRegistry';
import { isChecklistItemValid } from '../helpers/workflow';

const RenderDynamicComponent = (
  workflowInstance: any,
  item: any,
  componentItem: any,
  i18n: any,
  path: string,
  namespace: string
) => {
  const metadata = item?.metadata && JSON.parse(item.metadata);
  const props = metadata?.ui?.component;
  const elementNamePath = `${path ? `${path}.` : ''}${item.code}`;
  const elementName = i18n(elementNamePath, {
    ns: namespace,
    defaultValue: props?.name || item?.name,
  });

  const itemCode = item?.code;
  const metas = item?.isValid && JSON.parse(item.isValid);
  const itemIsValid = isChecklistItemValid(item);
  const metasResponse = metas?.response;
  const metasResponseType = metasResponse?.typeResponse?.type;

  const { handler, allowEdit = null, data = {}, more = {} } = componentItem || {};

  const workflowInstanceData = workflowInstance?.data && JSON.parse(workflowInstance.data);
  const workflowDataChecklistItem =
    workflowInstanceData?.scope?.checklistItem?.hasOwnProperty(itemCode);

  const commonProps = {
    key: props?.id,
    props,
    elementName,
    others: {
      handler,
      checklistItem: item,
      data,
      record: workflowInstance,
      metasResponse,
      allowEdit,
    },
  };

  if (props?.type === 'list') {
    const ComponentToRender = getStep(props?.typeComponent);
    return <ComponentToRender {...{ props, item }} />;
  }

  if (props?.type !== undefined) {
    if (!itemIsValid) {
      if (metas?.noMoreAttempts) {
        return RenderMessageWithIcon(
          <ErrorOutlineRounded fontSize="small" sx={{ color: 'red', marginRight: '10px' }} />,
          metasResponse?.message
        );
      }

      return (
        <div style={{ marginLeft: '16px' }}>
          {RenderComponent({ ...commonProps, type: props?.type })}
        </div>
      );
    }

    return metasResponseType ? (
      <div style={{ marginLeft: '16px' }}>
        {RenderComponent({ ...commonProps, type: metasResponseType })}
      </div>
    ) : (
      RenderMessageWithIcon(
        <CheckIcon
          fontSize="small"
          sx={{ color: 'green', marginRight: '10px', marginLeft: '16px' }}
        />,
        metasResponse?.message || elementName
      )
    );
  }

  if (!itemIsValid) {
    if (metas?.response?.message && workflowDataChecklistItem) {
      const content = metasResponseType ? (
        <div style={{ marginLeft: '16px' }}>
          {RenderComponent({ ...commonProps, type: metasResponseType })}
        </div>
      ) : (
        metas?.response?.message
      );

      return RenderMessageWithIcon(
        <ErrorOutlineRounded
          fontSize="small"
          sx={{ color: 'red', marginRight: '10px', marginLeft: '16px' }}
        />,
        content
      );
    }

    return (
      <div
        className={`btn-${elementName.toLowerCase()}`}
        style={{ marginBottom: 10, marginLeft: '16px' }}
      >
        <ItemButton
          onClick={
            handler
              ? () =>
                  handler({
                    checklistItem: item,
                    more,
                  })
              : () => console.log('missing handler to this item...')
          }
        >
          {elementName} {item?.isRequired && '*'}
        </ItemButton>
      </div>
    );
  }

  const successContent = metasResponseType ? (
    <div>{RenderComponent({ ...commonProps, type: metasResponseType })}</div>
  ) : (
    metas?.response?.message
  );

  return RenderMessageWithIcon(
    <CheckIcon fontSize="small" sx={{ color: 'green', marginRight: '10px', marginLeft: '16px' }} />,
    successContent
  );
};

export default RenderDynamicComponent;
